// extracted by mini-css-extract-plugin
export default {"cardSeplag":"CardSeplag_cardSeplag__TFr20","buttonIncluir":"CardSeplag_buttonIncluir__RgBZ4"};